import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/SignupForm")
);

const SignUpFormEditConfig = {
  emptyLabel: "Sign Up Form",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props) => {
  const VOI = props.listVOI?.split(",");

  return {
    component: "Sign Up Form",
    props: {
      ...props,
      headline: props.header,
      subHeading: props.subHeadline,
      formLabels: {
        firstNameLabel: props.firstName,
        firstNameErrorMsg: props.firstNameErrorMsg,
        lastNameLabel: props.lastName,
        lastNameErrorMsg: props.lastNameErrorMsg,
        emailLabel: props.email,
        emailErrorMsg: props.emailErrorMsg,
        zipLabel: props.zipCode,
        zipErrorMsg: props.zipCodeErrorMsg,
        phoneLabel: props.phone,
        phoneErrorMsg: props.phoneErrorMsg,
        horizonLabel: props.phHeadline,
        horizonPlaceholder: props.phPlaceHolder,
        multiSelectLabel: props.labelVOI,
        mayContactLabel: props.dealerCBLabel,
        preferredDealersLabel: props.dealerOptnHeadline,
      },
      serverErrorMessaging: {
        errorHeader: props.errorHeader,
        errorDescription: props.errorDescription,
      },
      models: VOI?.map((model) => ({
        value: model,
        label: model,
        isFixed: props.defaultVOI === model,
      })),
      multiSelectLabel: props.labelVOI,
      privacyRightsHeading: props.privacyHeader,
      privacyRightsText: props.privacyMainText,
      submitCta: props.cta,
      confirmationHeadline: props.tyTitle,
      confirmationSubline: props.tyMessage,
    },
  };
};

const SignUpForm = (props) => {
  const data = transformData(props);
  return <Component {...data.props} />;
};

export default withAemIntegration("lexus/components/sign-up-form")(
  SignUpForm,
  SignUpFormEditConfig
);
